const OTHER_PARENT_CATEGORY_KEYS = new Set([
  "other",
  "autres",
  "otro",
  "others",
]);

const OTHER_MATERIAL_REFERENCE_KEYS = new Set([
  "other",
  "autres",
  "otro",
  "others",
]);

const normalizeKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const isOtherParentCategory = (categoryKey) =>
  OTHER_PARENT_CATEGORY_KEYS.has(normalizeKey(categoryKey));

const isOtherMaterialReference = (referenceName) =>
  OTHER_MATERIAL_REFERENCE_KEYS.has(normalizeKey(referenceName));

/**
 * Tri catégories parentes : alphabétique sur le libellé affiché, « Autres » en dernier.
 */
export const compareParentCategories = (a, b, getLabel, collator) => {
  const aIsOther = isOtherParentCategory(a);
  const bIsOther = isOtherParentCategory(b);
  if (aIsOther !== bIsOther) return aIsOther ? 1 : -1;
  return collator.compare(getLabel(a), getLabel(b));
};

/**
 * Tri matières enfant : alphabétique sur le libellé affiché, « Autres » en dernier.
 */
export const compareSortingMaterials = (a, b, getLabel, collator) => {
  const aIsOther = isOtherMaterialReference(a?.referenceName);
  const bIsOther = isOtherMaterialReference(b?.referenceName);
  if (aIsOther !== bIsOther) return aIsOther ? 1 : -1;
  return collator.compare(getLabel(a), getLabel(b));
};
